import { render, staticRenderFns } from "./SyncModal.vue?vue&type=template&id=408a80d1"
import script from "./SyncModal.vue?vue&type=script&lang=js"
export * from "./SyncModal.vue?vue&type=script&lang=js"
import style0 from "./SyncModal.vue?vue&type=style&index=0&id=408a80d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports